import React, { useState } from "react";
import styles from "./searchPosts.module.css";
import PostsSearchResults from "../postsSearchResults/PostsSearchResults";
import axios from "axios";
import { FaMagnifyingGlass } from "react-icons/fa6";

const apiUrl = process.env.REACT_APP_URL;

const SearchPosts = () => {
  /* The SearchPosts component allows the user to search for posts published on the website. The user enters a search query, which is checked against posts text contents. Search results are displayed using the PostsSearchResults component. */

  const [searchQuery, setSearchQuery] = useState("");
  const [searchDone, setSearchDone] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [offset, setOffset] = useState(0);
  const [moreResults, setMoreResults] = useState(true);

  /**
   * Handle search query change
   */
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
    setSearchDone(false);
  };

  /**
   * Handle form submission - get results from the database.
   */
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setMoreResults(true);
    getResults(0); // Start from offset 0 for a new search
  };

  /**
   * Search the database for posts that contain the current searchQuery.
   * @param {*} currentOffset - the number of search results to skip.
   */
  const getResults = async (currentOffset) => {
    try {
      const res = await axios.get(`${apiUrl}/search/posts`, {
        withCredentials: true,
        params: {
          search_query: searchQuery,
          qty: 10,
          offset: currentOffset,
        },
      });

      if (res.data) {
        if (res.data.posts.length < 10) {
          setMoreResults(false);
        }

        if (currentOffset === 0) {
          setSearchResults(res.data.posts);
        } else {
          setSearchResults([...searchResults, ...res.data.posts]);
        }

        setSearchDone(true);
      } else {
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  /**
   * Get more results from the database.
   */
  function handleViewMoreClick() {
    const newOffset = offset + 10;
    setOffset(newOffset);
    getResults(newOffset);
  }

  return (
    <div className={styles.searchPosts}>
      <form onSubmit={handleFormSubmit}>
        <p>I'm looking for posts that contain the following keyword(s):</p>
        <div className={styles.searchInputContainer}>
          <div>
            <input
              type="text"
              placeholder="Learning techniques"
              value={searchQuery}
              onChange={handleInputChange}
            />
          </div>

          <div className={styles.btnContainer}>
            <button>
              {" "}
              Search{" "}
              <span className={styles.searchBtnIcon}>
                <FaMagnifyingGlass />
              </span>
            </button>
          </div>
        </div>
      </form>

      {searchDone && (
        <PostsSearchResults
          postsResults={searchResults}
          keywordsStr={searchQuery || ""}
        />
      )}

      {searchDone && moreResults && (
        <button className={styles.viewMoreBtn} onClick={handleViewMoreClick}>
          View More
        </button>
      )}
    </div>
  );
};

export default SearchPosts;
